import React, { useEffect, useState, useCallback } from "react";
import { Table, Spinner, Form } from "react-bootstrap";
import Layout from "../../layout/Layout";
import { getSureAnaliz } from "../../../api/uretim/makineDataApi";
import GunlukSureChart from "../../../components/charts/GunlukSureChart";
import MakineAylikPayChart from "../../../components/charts/MakineAylikPayChart";
import AylikMakineSureChart from "../../../components/charts/AylikMakineSureChart";

function MakineSureAnaliz() {
  const [data, setData] = useState([]);
  const [year, setYear] = useState("2026");
  const [month, setMonth] = useState("Ocak");
  const [loading, setLoading] = useState(false);
  const [openGun, setOpenGun] = useState(null);

  const fetchData = useCallback(async () => {
    try {
      setLoading(true);
      const res = await getSureAnaliz(year);
      if (res.data?.data) setData(res.data.data);
    } catch (err) {
      console.error("Veri çekme hatası:", err);
    } finally {
      setLoading(false);
    }
  }, [year]);

  useEffect(() => {
    fetchData();
  }, [fetchData]);

  // Seçilen ayın detay verisini bul
  const selectedMonthData = data.find((item) => item.ay === month);

  return (
    <Layout>
      <div className="p-4">
        {/* Başlık ve filtre */}
        <div className="d-flex align-items-center justify-content-between mb-4">
          <h2 className="fw-bold">Üretim Süre Analiz</h2>
          <Form.Select
            value={year}
            onChange={(e) => setYear(e.target.value)}
            style={{ width: 180 }}
          >
            <option value="2026">2026</option>
            <option value="2025">2025</option>
            <option value="2024">2024</option>
          </Form.Select>
        </div>

        {/* 2️⃣ Günlük detay tablosu */}
        {!loading && (
          <>
            <div className="d-flex align-items-center justify-content-between mt-5 mb-3">
              <h4 className="fw-bold">
                Günlük Detay ({year} - {month})
              </h4>
              <Form.Select
                value={month}
                onChange={(e) => setMonth(e.target.value)}
                style={{ width: 160 }}
              >
                {data.map((d) => (
                  <option key={d.ay} value={d.ay}>
                    {d.ay}
                  </option>
                ))}
              </Form.Select>
            </div>

            {selectedMonthData ? (
              <div style={{ overflowX: "auto", maxHeight: "70vh" }}>
                <Table
                  bordered
                  hover
                  responsive
                  className="shadow-sm align-middle"
                >
                  <thead className="table-light">
                    <tr>
                      <th>Gün</th>
                      <th>Makina 1 (dk)</th>
                      <th>Makina 2 (dk)</th>
                      <th>Makina 3 (dk)</th>
                      <th>Makina 4 (dk)</th>
                      <th>Toplam Süre (dk)</th>
                      <th>Vardiya Sayısı</th>
                      <th>Vardiya Kapasite</th>
                      <th>Oran (%)</th>
                    </tr>
                  </thead>
                  <tbody>
                    {selectedMonthData.gunluk.map((gunData, i) => {
                      const m1 =
                        gunData.makinalar.find((m) => m.makinaAdi === "1")
                          ?.toplamSure || 0;
                      const m2 =
                        gunData.makinalar.find((m) => m.makinaAdi === "2")
                          ?.toplamSure || 0;
                      const m3 =
                        gunData.makinalar.find((m) => m.makinaAdi === "3")
                          ?.toplamSure || 0;
                      const m4 =
                        gunData.makinalar.find((m) => m.makinaAdi === "4")
                          ?.toplamSure || 0;

                      // 🔥 detayları makina bazlı ayır
                      const detayByMakina = gunData.detaylar?.reduce(
                        (acc, d) => {
                          if (!acc[d.makinaAdi]) acc[d.makinaAdi] = [];
                          acc[d.makinaAdi].push(d);
                          return acc;
                        },
                        {}
                      );

                      return (
                        <React.Fragment key={i}>
                          {/* ================= ANA GÜN SATIRI ================= */}
                          <tr>
                            <td>
                              <button
                                className="btn btn-sm btn-outline-primary me-2"
                                onClick={() =>
                                  setOpenGun(
                                    openGun === gunData.gun ? null : gunData.gun
                                  )
                                }
                              >
                                {openGun === gunData.gun ? "−" : "+"}
                              </button>
                              {gunData.gun}
                            </td>

                            <td>{m1.toLocaleString()}</td>
                            <td>{m2.toLocaleString()}</td>
                            <td>{m3.toLocaleString()}</td>
                            <td>{m4.toLocaleString()}</td>

                            <td className="fw-bold text-primary">
                              {gunData.gunlukToplamDk?.toLocaleString() || 0}
                            </td>

                            <td className="fw-bold text-success">
                              {gunData.vardiyaSayisi?.toFixed(2) || 0}
                            </td>

                            <td className="text-muted">
                              {gunData.vardiyaKapasite || 12}
                            </td>

                            <td
                              className={
                                gunData.oran >= 1
                                  ? "text-success fw-bold"
                                  : gunData.oran >= 0.75
                                  ? "text-warning fw-bold"
                                  : "text-danger fw-bold"
                              }
                            >
                              {(gunData.oran * 100).toFixed(1)}%
                            </td>
                          </tr>

                          {/* ================= DETAY SATIRI ================= */}
                          {openGun === gunData.gun && (
                            <tr className="bg-light">
                              {/* Gün kolonu boş */}
                              <td></td>

                              {/* ===== MAKİNA 1 ===== */}
                              <td className="align-top p-1">
                                {detayByMakina?.["1"]?.map((d, idx) => (
                                  <div
                                    key={idx}
                                    className="border-bottom small mb-1"
                                  >
                                    <div>
                                      <b>{d.operator}</b>
                                    </div>
                                    <div>Süre: {d.toplamSure} dk</div>
                                    <div>Duruş: {d.durusToplamDk} dk</div>
                                    <div>Tonaj: {d.tonajKg}</div>
                                  </div>
                                ))}
                              </td>

                              {/* ===== MAKİNA 2 ===== */}
                              <td className="align-top p-1">
                                {detayByMakina?.["2"]?.map((d, idx) => (
                                  <div
                                    key={idx}
                                    className="border-bottom small mb-1"
                                  >
                                    <div>
                                      <b>{d.operator}</b>
                                    </div>
                                    <div>Süre: {d.toplamSure} dk</div>
                                    <div>Duruş: {d.durusToplamDk} dk</div>
                                    <div>Tonaj: {d.tonajKg}</div>
                                  </div>
                                ))}
                              </td>

                              {/* ===== MAKİNA 3 ===== */}
                              <td className="align-top p-1">
                                {detayByMakina?.["3"]?.map((d, idx) => (
                                  <div
                                    key={idx}
                                    className="border-bottom small mb-1"
                                  >
                                    <div>
                                      <b>{d.operator}</b>
                                    </div>
                                    <div>Süre: {d.toplamSure} dk</div>
                                    <div>Duruş: {d.durusToplamDk} dk</div>
                                    <div>Tonaj: {d.tonajKg}</div>
                                  </div>
                                ))}
                              </td>

                              {/* ===== MAKİNA 4 ===== */}
                              <td className="align-top p-1">
                                {detayByMakina?.["4"]?.map((d, idx) => (
                                  <div
                                    key={idx}
                                    className="border-bottom small mb-1"
                                  >
                                    <div>
                                      <b>{d.operator}</b>
                                    </div>
                                    <div>Süre: {d.toplamSure} dk</div>
                                    <div>Duruş: {d.durusToplamDk} dk</div>
                                    <div>Tonaj: {d.tonajKg}</div>
                                  </div>
                                ))}
                              </td>

                              {/* Sağ taraf boş */}
                              <td colSpan={4}></td>
                            </tr>
                          )}
                        </React.Fragment>
                      );
                    })}
                  </tbody>
                </Table>
              </div>
            ) : (
              <div className="text-muted text-center mt-3">
                Bu aya ait günlük veri bulunamadı.
              </div>
            )}
            {selectedMonthData && (
              <>
                <GunlukSureChart selectedMonthData={selectedMonthData} />
                <MakineAylikPayChart selectedMonthData={selectedMonthData} />
              </>
            )}
          </>
        )}

        {/* 1️⃣ Yıllık toplam tablo */}
        {loading ? (
          <div className="d-flex justify-content-center mt-5">
            <Spinner animation="border" />
          </div>
        ) : (
          <div style={{ overflowX: "auto" }}>
            <Table bordered hover responsive className="shadow-sm align-middle">
              <thead className="table-light">
                <tr>
                  <th>Ay</th>
                  <th>Makina 1 (dk)</th>
                  <th>Makina 2 (dk)</th>
                  <th>Makina 3 (dk)</th>
                  <th>Makina 4 (dk)</th>
                  <th>Toplam (dk)</th>
                </tr>
              </thead>
              <tbody>
                {data.map((ayData, i) => {
                  const m1 =
                    ayData.ayToplam?.find((m) => m.makinaAdi === "1")
                      ?.toplamSure || 0;
                  const m2 =
                    ayData.ayToplam?.find((m) => m.makinaAdi === "2")
                      ?.toplamSure || 0;
                  const m3 =
                    ayData.ayToplam?.find((m) => m.makinaAdi === "3")
                      ?.toplamSure || 0;
                  const m4 =
                    ayData.ayToplam?.find((m) => m.makinaAdi === "4")
                      ?.toplamSure || 0;
                  const toplam = m1 + m2 + m3 + m4;

                  return (
                    <tr key={i}>
                      <td>{ayData.ay}</td>
                      <td>{m1.toLocaleString()}</td>
                      <td>{m2.toLocaleString()}</td>
                      <td>{m3.toLocaleString()}</td>
                      <td>{m4.toLocaleString()}</td>
                      <td>{toplam.toLocaleString()}</td>
                    </tr>
                  );
                })}
              </tbody>
            </Table>
          </div>
        )}
        {data.length > 0 && <AylikMakineSureChart data={data} />}
      </div>
    </Layout>
  );
}

export default MakineSureAnaliz;
